import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'
import { IStudyReviewerResult } from './getStudyReviewer'

interface IRemoveTechnicianResponseBody {
  technician: IStudyReviewerResult
}

export interface IRemoveTechnicianResponse extends AxiosResponse {
  data: IRemoveTechnicianResponseBody
}

export function removeTechnician(token: string, reviewerId: string, technicianId: string): Promise<IRemoveTechnicianResponse> {
  const url = `/study/reviewer/${reviewerId}/technicians/${technicianId}`;
  return Client.delete(url, { ...authHeaders(token), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/removeTechnician.ts